import { Routes } from '@angular/router';
import { MainComponent } from './main.component';

export default [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'meet-list',
      },
      {
        path: 'meet-list', // :date/:location
        loadComponent: () => import('./meet-home/meet-home.component').then((c) => c.MeetHomeComponent),
      },
      { path: 'get', loadComponent: () => import('../page/get/get.component').then((c) => c.GetComponent) },
      { path: 'about', loadComponent: () => import('../page/about/about.component').then((c) => c.AboutComponent) },
      {
        path: 'contact',
        loadComponent: () => import('../page/contact/contact.component').then((c) => c.ContactComponent),
      },
      {
        path: 'pricing',
        loadComponent: () => import('../page/pricing/pricing.component').then((c) => c.PricingComponent),
      },
      {
        path: 'athletic-field',
        loadComponent: () =>
          import('../page/athletic-field/athletic-field.component').then((c) => c.AthleticFieldComponent),
      },
      {
        path: 'athletic-sb',
        loadComponent: () => import('../page/athletic-sb/athletic-sb.component').then((c) => c.AthleticSbComponent),
      },
      {
        path: 'features/notifications',
        loadComponent: () =>
          import('../page/features/notifications/notifications.component').then((c) => c.NotificationsComponent),
      },
      {
        path: 'features/search',
        loadComponent: () => import('../page/features/search/search.component').then((c) => c.SearchComponent),
      },
      {
        path: 'features/results',
        loadComponent: () => import('../page/features/results/results.component').then((c) => c.ResultsComponent),
      },
      {
        path: 'features/scoreboard',
        loadComponent: () =>
          import('../page/features/scoreboard/scoreboard.component').then((c) => c.ScoreboardComponent),
      },
      {
        path: 'features/video',
        loadComponent: () => import('../page/features/video/video.component').then((c) => c.VideoComponent),
      },
      {
        path: 'for/athletes',
        loadComponent: () => import('../page/for/athletes/athletes.component').then((c) => c.AthletesComponent),
      },
      {
        path: 'for/coaches',
        loadComponent: () => import('../page/for/coaches/coaches.component').then((c) => c.CoachesComponent),
      },
      {
        path: 'for/meet-directors',
        loadComponent: () =>
          import('../page/for/meet-directors/meet-directors.component').then((c) => c.MeetDirectorsComponent),
      },
      {
        path: 'for/parents',
        loadComponent: () => import('../page/for/parents/parents.component').then((c) => c.ParentsComponent),
      },
      {
        path: 'for/timers',
        loadComponent: () => import('../page/for/timers/timers.component').then((c) => c.TimersComponent),
      },
      {
        path: 'result-tables',
        loadComponent: () => import('./result-tables/result-tables.component').then((c) => c.ResultTablesComponent),
        children: [
          {
            path: ':modalType/:modalId',
            loadComponent: () =>
              import('../athlete/modal-entry/modal-entry.component').then((c) => c.ModalEntryComponent),
          },
        ],
      },
    ],
  },
  {
    path: 'branding-helper',
    loadComponent: () => import('./branding-helper/branding-helper.component').then((c) => c.BrandingHelperComponent),
  },
  {
    path: 'skin-branding-helper',
    loadComponent: () =>
      import('./skin-branding-helper/skin-branding-helper.component').then((c) => c.SkinBrandingHelperComponent),
  },
] as Routes;
